import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'abbreviateNumber'
})
export class NumberAbbreviationPipe implements PipeTransform {

  /**
   * args: currency. Ex: inr,usd
   */
  transform(value: any, args?: any): any {
    if (value > 999 && value < 999999) {
      return (value / 1000).toFixed(1) + 'k';
    } if (value > 999999 && value < 999999999) {
      return (value / 1000000).toFixed(1) + 'M';
    } else {
      return value;
    }
  }

}
